import { action } from './index';

export const SET_ACTIVE_CONVERSATION = 'SET_ACTIVE_CONVERSATION';
export const selectConversation = data => action(SET_ACTIVE_CONVERSATION, { room: data });
